//Material
import { Grid, Skeleton, Stack } from "@mui/material";
//Components
import UserProfileDetailInformation from "./UserProfileDetailInformation";
import UserTextField from "./UserTextField";
import { ICommunication, IUser } from "@/Common/interfaces/user";
import UserProfilePhones from "./UserProfilePhones";
//Interfaces and Types
import { TUserProfileContainerDetailsProps } from "../../types/UserProfile";

const getCommunicationData = (userObj: IUser | null, type: string, usage = "BUSINESS"): string => {
	const obj = userObj?.communications?.find((item: ICommunication) => {
		if (usage && item.communicationType === type && item.usage === usage) {
			return item;
		}
		return item.communicationType === type && item.usage === usage;
	});

	return obj?.value ?? "";
};

export default function UserProfileContainerDetails({ isLoading, user }: Readonly<TUserProfileContainerDetailsProps>) {
	return (
		<Grid container justifyContent={"center"} className={"userprofile-container"}>
			<Grid
				container
				item
				xs={12}
				md={7}
				direction={"row"}
				justifyContent={"center"}
				className={"userprofile-container"}
				rowSpacing={2}
			>
				<UserProfileDetailInformation
					name="Email Address"
					isLoading={isLoading}
					componentLoadingTrue={<Skeleton variant="rectangular" className="rounded !h-[30px]" />}
					componentLoadingFalse={<UserTextField value={getCommunicationData(user, "EMAIL") || ""} />}
				/>

				<UserProfileDetailInformation
					name="Phone Number"
					isLoading={isLoading}
					componentLoadingTrue={
						<Stack justifyContent={"space-between"} direction={"row"}>
							<Skeleton variant="rectangular" className="rounded !w-[200px] !h-[30px]" />
							<Skeleton variant="rectangular" className="rounded !w-[200px] !h-[30px]" />
						</Stack>
					}
					componentLoadingFalse={
						<Grid container justifyContent={"space-between"} direction={"row"} style={{ width: "calc(100% + 16px)" }}>
							<UserProfilePhones user={user} />
						</Grid>
					}
				/>

				<UserProfileDetailInformation
					name="Employee ID"
					isLoading={isLoading}
					componentLoadingTrue={<Skeleton variant="rectangular" className="rounded !h-[30px]" />}
					componentLoadingFalse={<UserTextField value={user?.employeeId ?? ""} />}
				/>

				<UserProfileDetailInformation
					name="Supervisor"
					isLoading={isLoading}
					componentLoadingTrue={<Skeleton variant="rectangular" className="rounded !h-[30px]" />}
					componentLoadingFalse={<UserTextField value={user?.supervisor?.fullName ?? "Unknown"} />}
				/>
			</Grid>
		</Grid>
	);
}
